import type { UseCaseType } from './UseCase';

export type GenogramAssistantRole =
  | 'family-therapist'
  | 'genetic-counselor'
  | 'case-worker'
  | 'legal-estate-planner'
  | 'researcher'
  | 'genealogist'
  | 'educator';

export const GENOGRAM_ASSISTANT_ROLE_OPTIONS: Array<{
  value: GenogramAssistantRole;
  label: string;
}> = [
  { value: 'family-therapist', label: 'Family Therapist' },
  { value: 'genetic-counselor', label: 'Genetic Counselor / Medical' },
  { value: 'case-worker', label: 'Social Worker / Case Worker' },
  { value: 'legal-estate-planner', label: 'Legal / Estate Planner' },
  { value: 'researcher', label: 'Researcher' },
  { value: 'genealogist', label: 'Genealogist' },
  { value: 'educator', label: 'Educator' },
];

export function inferAssistantRoleFromUseCase(useCase: UseCaseType | null): GenogramAssistantRole | null {
  switch (useCase) {
    case 'family-therapy':
      return 'family-therapist';
    case 'medical-genetic':
      return 'genetic-counselor';
    case 'social-work':
      return 'case-worker';
    case 'legal-estate':
      return 'legal-estate-planner';
    case 'general-research':
      return 'researcher';
    case 'blank':
    default:
      return null;
  }
}
